import { render, staticRenderFns } from "./applyPolicy.vue?vue&type=template&id=8c7e11dc&scoped=true&"
import script from "./applyPolicy.vue?vue&type=script&lang=js&"
export * from "./applyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./applyPolicy.vue?vue&type=style&index=0&id=8c7e11dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7e11dc",
  null
  
)

export default component.exports